import { render, staticRenderFns } from "./StorageComponent.vue?vue&type=template&id=988ba3ec"
import script from "./StorageComponent.vue?vue&type=script&lang=js"
export * from "./StorageComponent.vue?vue&type=script&lang=js"
import style0 from "./StorageComponent.vue?vue&type=style&index=0&id=988ba3ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports